<template>
  <div class="rounded-2xl border border-[#1c4848]/10 bg-white p-3">
    <div class="overflow-hidden rounded-2xl bg-[#1c4848]/5">
      <img v-if="attrs.image" :src="attrs.image" alt="" class="aspect-[16/10] w-full object-cover" draggable="false">
      <ImagePicker v-else-if="!readOnly" :context="context" :has-image="false" class="min-h-[220px]" @picked="set({ image: $event })" />
    </div>
    <div class="relative -mt-12 w-[78%] rounded-2xl bg-[#1c4848] p-3 shadow-xl" :class="attrs.side === 'right' ? 'me-3 ms-auto' : 'ms-3'">
      <BlockField :model-value="attrs.title" on-dark placeholder="Title" :read-only="readOnly" input-class="font-display text-lg font-bold text-white" @update:model-value="set({ title: $event })" />
      <BlockField :model-value="attrs.text" on-dark placeholder="A few lines on the card" :read-only="readOnly" input-class="text-sm leading-relaxed text-white/90" @update:model-value="set({ text: $event })" />
    </div>
    <div v-if="!readOnly" class="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1">
      <ImagePicker v-if="attrs.image" :context="context" has-image compact @picked="set({ image: $event })" />
      <OptionGroup label="Card" :value="attrs.side" :options="SIDE_OPTIONS" @pick="set({ side: $event })" />
    </div>
  </div>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ImagePicker from '@/components/writer/views/ImagePicker.vue';
import OptionGroup from '@/components/writer/views/OptionGroup.vue';

const SIDE_OPTIONS = [{ value: 'left', label: 'Left' }, { value: 'right', label: 'Right' }];

defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
</script>
